<template>
  <div class="form-group">
    <slot></slot>
    <validation-provider name="location" ref="location" rules="required" v-slot="{ errors }" mode="eager">
      <input type="hidden" name="location_id" :id="id" :value="selected ? selected.id : selected">
      <v-select
        v-model="selected"
        label="city"
        :options="paginated"
        :filterable="false"
        :clearable="clearable"
        :placeholder="placeholder"
        @open="onOpen"
        @close="onClose"
        @search="query => search = query"
        @input="$emit('input', $event ? $event.id : $event)"
        :get-option-label="getOptionLabel"
      >
        <template slot="no-options">
          {{ trans.get('auth.locations.suggestion') }}
        </template>
        <template slot="option" slot-scope="{ zip_code, city, country }">
          <div class="d-center">
            {{ zip_code }} {{ city }} ({{ country }})
          </div>
        </template>
        <template v-slot:selected-option="{ zip_code, city, country }">
          <div class="selected d-center">
            {{ zip_code }} {{ city }} ({{ country }})
          </div>
        </template>
        <template #list-footer>
          <li ref="load" class="loader" v-show="hasNextPage">
            {{ trans.get('auth.locations.loading') }}
          </li>
        </template>
      </v-select>
      <span class="text-danger">{{ errors[0] }}</span>
    </validation-provider>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css';
import { mapGetters } from 'vuex';

export default {
  props: {
    id: {
      type: String,
      default: 'location-id'
    },
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: String | Number,
  },
  data: function () {
    return {
      selected: '',
      observer: new IntersectionObserver(this.infiniteScroll),
      limit: 10,
      search: '',
    };
  },
  computed: {
    ...mapGetters('locations', {
      locations: 'getLocations',
    }),
    filtered() {
      return this.locations.filter(location => {
        return (location.city.toLowerCase().includes(this.search.toLowerCase()) || location.zip_code.includes(this.search));
      });
    },
    paginated() {
      return this.filtered.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length;
    },
  },
  methods: {
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 10;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    initSelected() {
      if (this.value) {
        this.selected = this.locations.find((item) => item.id === parseInt(this.value));
      }
    },
    getOptionLabel(option) {
      return (option && option.city) || '';
    }
  },
  created() {
    const self = this;

    this.$store.dispatch('locations/load')
      .then(function () {
        self.initSelected();
      });
  },
};
</script>
<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
